import { render, staticRenderFns } from "./CreateInvestigation.vue?vue&type=template&id=07f13deb"
import script from "./CreateInvestigation.vue?vue&type=script&lang=js"
export * from "./CreateInvestigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports